<template>
  <a href="/" class="logo">
    <div class="logo__image">
      <icon class="logo__icon" name="logo" width="73" height="90" />
    </div>
    <div class="logo__title">
      Камчатский край
      <small class="logo__subtitle">официальный сайт</small>
    </div>
  </a>
</template>

<script>
import Icon from '../shared/Icon'

export default {
  components: {
    Icon
  }
}
</script>

<style lang="scss" scoped>
.logo {
  @include media-breakpoint-up(md) {
    color: $white;
    display: flex;
    flex-direction: row;
  }

  &:hover {
    color: $white;
    text-decoration: none;
  }

  &__image {
    margin-right: 16px;

    @include media-breakpoint-up(lg) {
      margin-right: 40px;
      height: 90px;
      width: 73px;
    }

    .icon {
      height: 30px;
      width: auto;

      @include media-breakpoint-up(lg) {
        height: auto;
      }
    }
  }

  &__title {
    @include font-size(38px);
    display: none;

    @include media-breakpoint-up(lg) {
      display: block;
    }
  }

  &__subtitle {
    @include font-size(21px);
    display: block;
  }
}
</style>
